import CatalogStarterContact from "../catalog_starter_contact";
import { ValidationForm } from '../../../src/web/validation_form'

const CATALOG_CONTACT_KEY = 'catalog_contact'

var CatalogContact = {
  init() {
    this.setDefaultCatalogsSelectedCount()
    this.setCheckedSelectCatalog()
    this.clearCatalogsSelected()
    this.addCatalogsSelect()
    this.displayListCatalogSelect()
    this.validateCatalogContact()
    this.removeContactFields()
    this.selectProductCatalog() // 規格住宅から遷移時
    this.selectCatalogByUrl()
    this.handleSubmitForm()
    CatalogStarterContact.setAttributesContact('#catalog_confirm', CATALOG_CONTACT_KEY)
    CatalogStarterContact.fillContactFields(CATALOG_CONTACT_KEY)
  },
  addCatalogsSelect() {
    $('.select_catalog').on('click', function () {
      let catalogItem = $(this)
      let catalogsSelectedJson = localStorage.getItem('catalogs_selected') || '[]'
      let catalogsSelected = JSON.parse(catalogsSelectedJson)

      let catalogObj = {
        id: catalogItem.attr('data-id'),
        name: catalogItem.attr('data-name'),
        cover_image_url: catalogItem.attr('data-cover_image_url'),
        alt_cover_image: catalogItem.attr('data-alt_cover_image')
      }

      const label = catalogItem.closest('.btn4').find('label')

      if (catalogItem.is(':checked')) {
        catalogsSelected.push(catalogObj)
        label.text('選択中')
      } else {
        catalogsSelected = catalogsSelected.filter(function( item ) {
          return item.id != catalogItem.attr('data-id');
        });
        label.text('カタログを選択する')
      }

      localStorage.setItem('catalogs_selected', JSON.stringify(catalogsSelected))
      localStorage.setItem('catalogs_selected_count', catalogsSelected.length)

      $('.catalogs_selected_count').each(function () {
        $(this).html(catalogsSelected.length)
      })
    })
  },
  setCheckedSelectCatalog () {
    $('.select_catalog').each(function () {
      let catalogsSelectedJson = localStorage.getItem('catalogs_selected') || '[]'
      let catalogsSelected = JSON.parse(catalogsSelectedJson)
      let checked = catalogsSelected.find(item => item.id == $(this).attr('data-id'))

      const label = $(`label[for='${$(this).attr('id')}']`)

      if (checked) {
        $(this).prop('checked', true)
        label.text ('選択中')
      }else {
        label.text ('カタログを選択する')
      }
    })
  },
  setDefaultCatalogsSelectedCount () {
    let catalogsSelectedCount = localStorage.getItem('catalogs_selected_count') || 0
    $('.catalogs_selected_count').each(function () {
      $(this).html(catalogsSelectedCount)
    })
  },
  clearCatalogsSelected () {
    $('.cancel').on('click', function (e) {
      e.preventDefault();
      localStorage.setItem('catalogs_selected', '[]')
      localStorage.setItem('catalogs_selected_count', '0')

      // MEMO: チェックボックスをすべてオフにする
      let catalogsCheckBoxes = $($('.select_catalog'));
      for(var i = 0; i < catalogsCheckBoxes.length; i++) {
        catalogsCheckBoxes[i].checked = false
      }

      $('.catalogs_selected_count').each(function () {
        $(this).html('0')
      })

      $('.select_catalog').siblings('label').text('カタログを選択する');
    })
  },
  displayListCatalogSelect () {
    let catalogsSelectedJson = localStorage.getItem('catalogs_selected') || '[]'
    let catalogsSelected = JSON.parse(catalogsSelectedJson)
    let catalogsSelectedItem = '';

    // MEMO: 確認画面（#catalog_contact_form）では catalog_ids をサーバー側で出力しているため、
    // ここで hidden field を追加すると二重送信になる。確認画面では表示のみ行う。
    const needsHiddenField = $('#catalog_contact_form').length === 0

    catalogsSelected.forEach(function (item) {
      const hiddenField = needsHiddenField
        ? `<input name="catalog_contact[catalog_ids][]" type="hidden" value="${item.id}">`
        : ''

      catalogsSelectedItem = `<li>
                                <h4>${item.name}</h4>
                                <figure class="img">
                                <img alt="${item?.alt_cover_image || ''}" src="${item?.cover_image_url}">
                                </figure>
                                ${hiddenField}
                              </li>`;

      $('#list_catalog_select').append(catalogsSelectedItem)
    })
  },
  removeContactFields () {
    $('#submit_contact').on('click', function () {
      localStorage.removeItem('catalog_contact')
      localStorage.removeItem('contact_address')
    })

    $('#complete_contact').on('click', function () {
      localStorage.removeItem('catalogs_selected')
      localStorage.removeItem('catalogs_selected_count')
    })
  },
  selectProductCatalog () {
    var params = (new URL(document.location)).searchParams;
    var product_catalog_id = params.get('product_catalog_id');
    if (product_catalog_id) {
      $('.select_catalog').each(function () {
        if ($(this).val() == product_catalog_id) {
          // product_catalog_id と一致するカタログの選択
          if (!$(this).is(':checked')) {
            $(this).click();
          }
        } else {
          // それ以外のカタログは選択を外す
          if ($(this).is(':checked')) {
            $(this).click();
          }
        }
      })
    }
  },
  validateCatalogContact () {
    $('#catalog_confirm').on('click', function (e) {
      if (!CatalogContact.handleCatalogsNotSelected(e)) {
        return false
      }

      if (!CatalogContact.isValid()) {
        $('#alertWrap').removeClass('d-none')
        $('#alertWrap').html('未入力項目があります')

        $('html, body').animate({
          scrollTop: $('#formWrap').offset().top
        }, 500);

        e.preventDefault();
        return false
      }
    })
  },
  isValid () {
    return CatalogStarterContact.isValidStarterCatalogContact()
  },
  handleCatalogsNotSelected (e) {
    let catalogsSelectedJson = localStorage.getItem('catalogs_selected') || '[]'
    let catalogsSelected = JSON.parse(catalogsSelectedJson)

    if (catalogsSelected.length === 0) {
      e.preventDefault();
      $('#alertWrap').removeClass('d-none')
      $('#alertWrap').html('カタログを選択してください。')

      $('html, body').animate({
        scrollTop: $('#formWrap').offset().top
      }, 500);

      return false
    }

    return true
  },
  selectCatalogByUrl: function () {
    const params = new window.URLSearchParams(window.location.search);
    const selectedID = params.get('selected_id')

    if (!selectedID) {
      return
    }

    let catalogsSelectedJson = localStorage.getItem('catalogs_selected') || '[]'
    let catalogsSelected = JSON.parse(catalogsSelectedJson)

    const catalogSelector = $('.List').find(`[data-id="${selectedID}"]`)

    catalogsSelected = catalogsSelected.filter(function( item ) {
      return item.id !== catalogSelector.attr('data-id');
    });

    localStorage.setItem('catalogs_selected', JSON.stringify(catalogsSelected))
    localStorage.setItem('catalogs_selected_count', catalogsSelected.length)

    catalogSelector.prop('checked', false)
    catalogSelector.trigger('click')
  },
  // 送信ボタンは f.submit（ネイティブ送信）に変更したため、ここでは送信を行わない。
  // Digima の dgm_bcn だけを hidden field に流し込む（JSが落ちてもフォーム自体は送信できる）。
  handleSubmitForm () {
    const $form = $('#catalog_contact_form')
    if (!$form.length) return

    const ValidateForm = new ValidationForm()
    ValidateForm.setDgmCookie()
    $form.on('submit', function() {
      ValidateForm.setDgmCookie()
    })
  }
}

export default CatalogContact
